<template>
  <teamplate v-if="version === 'v1'">
    <div class="tw-flex tw-flex-col">
      <div class="image-wrapper project property-image w-100">
        <library-image
          :src="property.image"
          :blur="imageBlurFilter"
          :pre-market-blur-text="preMarketBlurText"
        ></library-image>
        <div v-if="property.custom_property_status_title" class="nc-property-image-badge">
          {{ property.custom_property_status_title }}
        </div>
      </div>
      <div>
        <div class="mt-2 d-flex flex-row justify-content-between align-items-center" style="height: 70px">
          <template v-if="!property.is_locked">
            <div class="tw-flex tw-w-full tw-flex-row tw-items-center tw-justify-between">
              <div class="tw-flex tw-flex-col">
                <lazy-library-text class="n-capitalized" :text="property.price.type.name"></lazy-library-text>
                <lazy-library-text :text="property.price.price" type="value"></lazy-library-text>
              </div>
              <div
                v-if="property.match_percentage && !isMatchInformationHidden"
                class="tw-relative tw-flex tw-flex-row tw-items-center tw-gap-x-2"
              >
                <div
                  class="d-flex align-items-center tw-mr-2 tw-rounded-sm tw-p-2"
                  :style="[design.matchTagBg, design.matchTextColor]"
                >
                  <lazy-library-text :text="`${property.match_percentage} MATCH`" type="small"> </lazy-library-text>
                </div>
                <nc-tooltip>
                  <template #item>
                    <span class="nc-icon-info-circle d-flex align-items-center"></span>
                  </template>
                  <template #tooltip>
                    <lazy-library-title text="Match Score:" tag="h6" class="tw-mb-2 tw-pt-2"></lazy-library-title>
                    <lazy-library-text
                      tag="p"
                      text="                  This is a prediction of what our software thinks you may find
                    an interesting property, based on the unique search criteria
                    that you gave us. You can improve the relevance of your match
                    score by adjusting and saving your search criteria."
                    >
                    </lazy-library-text>
                  </template>
                </nc-tooltip>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="tw-flex tw-w-full tw-flex-row tw-items-center tw-justify-between">
              <div class="tw-mt-3 tw-flex tw-flex-row">Pre-market property</div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="tw-mt-3 tw-h-[84px]">
      <lazy-library-title
        tag="h4"
        :text="property.advert_heading"
        :style="design.advertHeadingColor"
      ></lazy-library-title>
    </div>
    <template v-if="!property.is_locked">
      <div class="tw-mt-3 tw-flex tw-h-[20px] tw-items-start tw-gap-x-3">
        <div class="tw-flex tw-items-center tw-gap-x-2">
          <span
            :class="isLetterPropertyCriteria ? 'tw-order-2 tw-pr-2' : 'tw-order-1'"
            :style="isLetterPropertyCriteria ? `border-right: 1px solid var(--default-border-color)` : ''"
          >
            <svg
              v-if="!isLetterPropertyCriteria"
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.6673 13.8333V12.8333M3.33398 13.8333V12.8333"
                stroke="#222222"
                stroke-width="0.8"
                stroke-linecap="round"
              />
              <path
                d="M14.0007 8.49996C14.0007 5.98596 14.0007 4.72863 13.2193 3.94796C12.4387 3.16663 11.1813 3.16663 8.66732 3.16663H7.33398C4.81998 3.16663 3.56265 3.16663 2.78198 3.94796C2.00065 4.72863 2.00065 5.98596 2.00065 8.49996M1.33398 10.5C1.33398 9.87863 1.33398 9.56796 1.43532 9.32329C1.50233 9.16141 1.60058 9.01433 1.72447 8.89044C1.84835 8.76656 1.99544 8.6683 2.15732 8.60129C2.40198 8.49996 2.71265 8.49996 3.33398 8.49996H12.6673C13.2887 8.49996 13.5993 8.49996 13.844 8.60129C14.0059 8.6683 14.153 8.76656 14.2768 8.89044C14.4007 9.01433 14.499 9.16141 14.566 9.32329C14.6673 9.56796 14.6673 9.87863 14.6673 10.5C14.6673 11.1213 14.6673 11.432 14.566 11.6766C14.499 11.8385 14.4007 11.9856 14.2768 12.1095C14.153 12.2334 14.0059 12.3316 13.844 12.3986C13.5993 12.5 13.2887 12.5 12.6673 12.5H3.33398C2.71265 12.5 2.40198 12.5 2.15732 12.3986C1.99544 12.3316 1.84835 12.2334 1.72447 12.1095C1.60058 11.9856 1.50233 11.8385 1.43532 11.6766C1.33398 11.432 1.33398 11.1213 1.33398 10.5Z"
                stroke="#222222"
                stroke-width="0.8"
              />
              <path
                d="M12.3346 8.49992V7.49992C12.3346 6.24259 12.3346 5.61459 11.944 5.22392C11.5533 4.83325 10.9253 4.83325 9.66797 4.83325H6.33464C5.0773 4.83325 4.4493 4.83325 4.05864 5.22392C3.66797 5.61459 3.66797 6.24259 3.66797 7.49992V8.49992M8.0013 5.16659V8.49992"
                stroke="#222222"
                stroke-width="0.8"
              />
            </svg>
            <span v-else-if="isLetterPropertyCriteria">BD</span>
          </span>
          <span :class="isLetterPropertyCriteria ? 'tw-order-1' : 'tw-order-2'">
            {{ property.bedroom }}
          </span>
        </div>
        <div class="tw-flex tw-items-center tw-gap-x-2">
          <span
            :class="isLetterPropertyCriteria ? 'tw-order-2 tw-pr-3' : 'tw-order-1'"
            :style="isLetterPropertyCriteria ? `border-right: 1px solid var(--default-border-color)` : ''"
          >
            <svg
              v-if="!isLetterPropertyCriteria"
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14 9.16667V11.1667C14 11.8739 13.719 12.5522 13.219 13.0523C12.7189 13.5524 12.0406 13.8333 11.3333 13.8333H4.66667C3.95942 13.8333 3.28115 13.5524 2.78105 13.0523C2.28095 12.5522 2 11.8739 2 11.1667V9.56667C2 9.46058 2.04214 9.35884 2.11716 9.28382C2.19217 9.20881 2.29391 9.16667 2.4 9.16667H14ZM14 9.16667V5.16667C14 4.45942 13.719 3.78115 13.219 3.28105C12.7189 2.78095 12.0406 2.5 11.3333 2.5H8M10.6667 13.8333L11.3333 15.1667M5.33333 13.8333L4.66667 15.1667"
                stroke="black"
                stroke-width="0.8"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M10.2663 5.83333H5.73294C5.51228 5.83333 5.33561 5.65467 5.35961 5.43467C5.45694 4.55 5.90828 2.5 7.99961 2.5C10.0909 2.5 10.5423 4.55 10.6396 5.43467C10.6636 5.65467 10.4869 5.83333 10.2663 5.83333Z"
                stroke="black"
                stroke-width="0.8"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <span v-else-if="isLetterPropertyCriteria">BA</span>
          </span>
          <span :class="isLetterPropertyCriteria ? 'tw-order-1' : 'tw-order-2'">
            {{ property.bathroom }}
          </span>
        </div>
        <div class="tw-flex tw-items-center tw-gap-x-2">
          <span :class="isLetterPropertyCriteria ? 'tw-order-2' : 'tw-order-1'">
            <svg
              v-if="!isLetterPropertyCriteria"
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5.93732 3.33337H10.064C10.6227 3.33337 10.9787 3.33337 11.2853 3.39404C11.8996 3.51623 12.4638 3.81782 12.9067 4.26068C13.3495 4.70354 13.6511 5.26778 13.7733 5.88204C13.82 6.11537 13.8307 6.37737 13.8333 6.73537C14.2174 6.84422 14.5556 7.07545 14.7963 7.39394C15.0371 7.71243 15.1673 8.10079 15.1673 8.50004V10.1294C15.1673 11.1494 14.6353 12.0454 13.834 12.554V13.1667C13.834 13.2993 13.7813 13.4265 13.6875 13.5203C13.5938 13.614 13.4666 13.6667 13.334 13.6667C13.2014 13.6667 13.0742 13.614 12.9804 13.5203C12.8867 13.4265 12.834 13.2993 12.834 13.1667V12.95C12.66 12.9834 12.4807 13 12.2967 13H3.70465C3.52065 13 3.34132 12.9827 3.16732 12.95V13.1667C3.16732 13.2993 3.11464 13.4265 3.02087 13.5203C2.9271 13.614 2.79993 13.6667 2.66732 13.6667C2.53471 13.6667 2.40753 13.614 2.31376 13.5203C2.22 13.4265 2.16732 13.2993 2.16732 13.1667V12.554C1.7587 12.2952 1.42218 11.9372 1.18906 11.5134C0.955936 11.0896 0.833791 10.6137 0.833985 10.13V8.50004C0.833985 7.66004 1.39798 6.95337 2.16798 6.73537C2.17065 6.37737 2.18132 6.11537 2.22798 5.88204C2.35017 5.26778 2.65177 4.70354 3.09463 4.26068C3.53749 3.81782 4.10172 3.51623 4.71598 3.39404C5.02265 3.33337 5.37865 3.33337 5.93732 3.33337ZM3.16865 6.73604C3.5523 6.84522 3.88989 7.0765 4.13026 7.39483C4.37063 7.71315 4.50066 8.10116 4.50065 8.50004V9.30004C4.50065 9.31871 4.51532 9.33337 4.53398 9.33337H11.4673C11.4762 9.33337 11.4846 9.32986 11.4909 9.32361C11.4971 9.31736 11.5007 9.30888 11.5007 9.30004V8.50004C11.5007 7.66137 12.064 6.95404 12.8327 6.73604C12.83 6.39604 12.8213 6.22271 12.7927 6.07737C12.7091 5.65698 12.5027 5.27081 12.1996 4.96773C11.8965 4.66465 11.5104 4.45827 11.09 4.37471C10.8927 4.33604 10.644 4.33337 10.0007 4.33337H6.00065C5.35732 4.33337 5.10865 4.33604 4.91132 4.37471C4.49092 4.45827 4.10476 4.66465 3.80168 4.96773C3.49859 5.27081 3.29222 5.65698 3.20865 6.07737C3.17998 6.22271 3.17132 6.39671 3.16865 6.73604ZM2.66732 7.66671C2.20732 7.66671 1.83398 8.04004 1.83398 8.50004V10.1294C1.83398 10.6255 2.03107 11.1013 2.38189 11.4521C2.73271 11.803 3.20852 12 3.70465 12H12.2967C12.7928 12 13.2686 11.803 13.6194 11.4521C13.9702 11.1013 14.1673 10.6255 14.1673 10.1294V8.50004C14.1673 8.27903 14.0795 8.06707 13.9232 7.91079C13.767 7.7545 13.555 7.66671 13.334 7.66671C13.113 7.66671 12.901 7.7545 12.7447 7.91079C12.5884 8.06707 12.5007 8.27903 12.5007 8.50004V9.30004C12.5007 9.5741 12.3918 9.83693 12.198 10.0307C12.0042 10.2245 11.7414 10.3334 11.4673 10.3334H4.53398C4.25993 10.3334 3.9971 10.2245 3.80331 10.0307C3.60952 9.83693 3.50065 9.5741 3.50065 9.30004V8.50004C3.50065 8.04004 3.12732 7.66671 2.66732 7.66671Z"
                fill="black"
              />
            </svg>
            <span v-else-if="isLetterPropertyCriteria">RE</span>
          </span>
          <span :class="isLetterPropertyCriteria ? 'tw-order-1' : 'tw-order-2'">
            {{ property.reception }}
          </span>
        </div>
      </div>
      <div v-if="!isSimpleVersion" class="tw-mt-3 tw-flex tw-h-[30px] tw-flex-row">
        <lazy-library-text :text="property.display_address" class="n-capitalized"></lazy-library-text>
      </div>
      <div
        v-if="!isSimpleVersion"
        class="mt-3 d-flex flex-row align-items-start tw-h-auto tw-gap-2 tw-pb-12 md:tw-h-[160px] md:tw-pb-0"
      >
        <div class="d-flex flex-column">
          <lazy-library-text :text="property.summary"></lazy-library-text>
        </div>
      </div>
    </template>
    <template v-else>
      <lazy-library-text
        :text="property.display_address"
        class="n-capitalized tw-mt-[44px] tw-min-h-[48px]"
      ></lazy-library-text>
      <p class="tw-my-1">
        This is a pre-market property. You need to create an account and register to our property alerts in order to
        view it.
      </p>
      <div class="tw-my-10 tw-flex tw-gap-x-2">
        <nuxt-link
          :to="routes.REGISTER"
          class="pxp-search-properties-btn tw-w-fit"
          style="background-color: var(--purple); color: var(--white)"
          :external="true"
          >Register</nuxt-link
        >
        <nuxt-link
          :to="`${routes.PROPERTY_DETAIL.replace(':propertyId', property.property_profile_id)}#login`"
          class="pxp-search-properties-btn tw-w-fit"
          style="background-color: var(--purple); color: var(--white)"
          :external="true"
          >Login</nuxt-link
        >
      </div>
    </template>
  </teamplate>

  <div v-if="version === 'v2'">
    <div class="tw-flex tw-flex-col">
      <div class="image-wrapper project property-image w-100">
        <library-image
          :src="property.image"
          :blur="imageBlurFilter"
          :pre-market-blur-text="preMarketBlurText"
        ></library-image>
        <div v-if="property.custom_property_status_title" class="nc-property-image-badge">
          {{ property.custom_property_status_title }}
        </div>
      </div>
      <div>
        <h5 class="tw-mt-3 tw-line-clamp-2 tw-h-[60px] tw-w-full tw-text-start">{{ property.advert_heading }}</h5>
        <div class="mt-2 d-flex flex-row justify-content-between align-items-center" style="height: 70px">
          <template v-if="!property.is_locked">
            <div class="tw-flex tw-w-full tw-flex-row tw-items-center tw-justify-between tw-text-start">
              <div class="tw-flex tw-flex-col">
                <p class="tw-uppercase">{{ property.price.type.name }}</p>
                <h5>{{ property.price.price }}</h5>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="tw-flex tw-w-full tw-flex-row tw-items-center tw-justify-between">
              <div class="tw-mt-3 tw-flex tw-flex-row">Pre-market property</div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <template v-if="!property.is_locked">
      <div class="tw-mt-3 tw-flex tw-h-[20px] tw-items-start tw-gap-x-3">
        <div class="tw-flex tw-items-center tw-gap-x-2">
          <span
            :class="isLetterPropertyCriteria ? 'tw-order-2 tw-pr-2' : 'tw-order-1'"
            :style="isLetterPropertyCriteria ? `border-right: 1px solid var(--default-border-color)` : ''"
          >
            <svg
              v-if="!isLetterPropertyCriteria"
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.6673 13.8333V12.8333M3.33398 13.8333V12.8333"
                stroke="var(--c-secondary)"
                stroke-width="0.8"
                stroke-linecap="round"
              />
              <path
                d="M14.0007 8.49996C14.0007 5.98596 14.0007 4.72863 13.2193 3.94796C12.4387 3.16663 11.1813 3.16663 8.66732 3.16663H7.33398C4.81998 3.16663 3.56265 3.16663 2.78198 3.94796C2.00065 4.72863 2.00065 5.98596 2.00065 8.49996M1.33398 10.5C1.33398 9.87863 1.33398 9.56796 1.43532 9.32329C1.50233 9.16141 1.60058 9.01433 1.72447 8.89044C1.84835 8.76656 1.99544 8.6683 2.15732 8.60129C2.40198 8.49996 2.71265 8.49996 3.33398 8.49996H12.6673C13.2887 8.49996 13.5993 8.49996 13.844 8.60129C14.0059 8.6683 14.153 8.76656 14.2768 8.89044C14.4007 9.01433 14.499 9.16141 14.566 9.32329C14.6673 9.56796 14.6673 9.87863 14.6673 10.5C14.6673 11.1213 14.6673 11.432 14.566 11.6766C14.499 11.8385 14.4007 11.9856 14.2768 12.1095C14.153 12.2334 14.0059 12.3316 13.844 12.3986C13.5993 12.5 13.2887 12.5 12.6673 12.5H3.33398C2.71265 12.5 2.40198 12.5 2.15732 12.3986C1.99544 12.3316 1.84835 12.2334 1.72447 12.1095C1.60058 11.9856 1.50233 11.8385 1.43532 11.6766C1.33398 11.432 1.33398 11.1213 1.33398 10.5Z"
                stroke="var(--c-secondary)"
                stroke-width="0.8"
              />
              <path
                d="M12.3346 8.49992V7.49992C12.3346 6.24259 12.3346 5.61459 11.944 5.22392C11.5533 4.83325 10.9253 4.83325 9.66797 4.83325H6.33464C5.0773 4.83325 4.4493 4.83325 4.05864 5.22392C3.66797 5.61459 3.66797 6.24259 3.66797 7.49992V8.49992M8.0013 5.16659V8.49992"
                stroke="var(--c-secondary)"
                stroke-width="0.8"
              />
            </svg>
            <span v-else-if="isLetterPropertyCriteria">BD</span>
          </span>
          <p :class="isLetterPropertyCriteria ? 'tw-order-1' : 'tw-order-2'">
            {{ property.bedroom }}
          </p>
        </div>
        <div class="tw-flex tw-items-center tw-gap-x-2">
          <span
            :class="isLetterPropertyCriteria ? 'tw-order-2 tw-pr-3' : 'tw-order-1'"
            :style="isLetterPropertyCriteria ? `border-right: 1px solid var(--default-border-color)` : ''"
          >
            <svg
              v-if="!isLetterPropertyCriteria"
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14 9.16667V11.1667C14 11.8739 13.719 12.5522 13.219 13.0523C12.7189 13.5524 12.0406 13.8333 11.3333 13.8333H4.66667C3.95942 13.8333 3.28115 13.5524 2.78105 13.0523C2.28095 12.5522 2 11.8739 2 11.1667V9.56667C2 9.46058 2.04214 9.35884 2.11716 9.28382C2.19217 9.20881 2.29391 9.16667 2.4 9.16667H14ZM14 9.16667V5.16667C14 4.45942 13.719 3.78115 13.219 3.28105C12.7189 2.78095 12.0406 2.5 11.3333 2.5H8M10.6667 13.8333L11.3333 15.1667M5.33333 13.8333L4.66667 15.1667"
                stroke="var(--c-secondary)"
                stroke-width="0.8"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M10.2663 5.83333H5.73294C5.51228 5.83333 5.33561 5.65467 5.35961 5.43467C5.45694 4.55 5.90828 2.5 7.99961 2.5C10.0909 2.5 10.5423 4.55 10.6396 5.43467C10.6636 5.65467 10.4869 5.83333 10.2663 5.83333Z"
                stroke="var(--c-secondary)"
                stroke-width="0.8"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <span v-else-if="isLetterPropertyCriteria">BA</span>
          </span>
          <p :class="isLetterPropertyCriteria ? 'tw-order-1' : 'tw-order-2'">
            {{ property.bathroom }}
          </p>
        </div>
        <div class="tw-flex tw-items-center tw-gap-x-2">
          <span :class="isLetterPropertyCriteria ? 'tw-order-2' : 'tw-order-1'">
            <svg
              v-if="!isLetterPropertyCriteria"
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5.93732 3.33337H10.064C10.6227 3.33337 10.9787 3.33337 11.2853 3.39404C11.8996 3.51623 12.4638 3.81782 12.9067 4.26068C13.3495 4.70354 13.6511 5.26778 13.7733 5.88204C13.82 6.11537 13.8307 6.37737 13.8333 6.73537C14.2174 6.84422 14.5556 7.07545 14.7963 7.39394C15.0371 7.71243 15.1673 8.10079 15.1673 8.50004V10.1294C15.1673 11.1494 14.6353 12.0454 13.834 12.554V13.1667C13.834 13.2993 13.7813 13.4265 13.6875 13.5203C13.5938 13.614 13.4666 13.6667 13.334 13.6667C13.2014 13.6667 13.0742 13.614 12.9804 13.5203C12.8867 13.4265 12.834 13.2993 12.834 13.1667V12.95C12.66 12.9834 12.4807 13 12.2967 13H3.70465C3.52065 13 3.34132 12.9827 3.16732 12.95V13.1667C3.16732 13.2993 3.11464 13.4265 3.02087 13.5203C2.9271 13.614 2.79993 13.6667 2.66732 13.6667C2.53471 13.6667 2.40753 13.614 2.31376 13.5203C2.22 13.4265 2.16732 13.2993 2.16732 13.1667V12.554C1.7587 12.2952 1.42218 11.9372 1.18906 11.5134C0.955936 11.0896 0.833791 10.6137 0.833985 10.13V8.50004C0.833985 7.66004 1.39798 6.95337 2.16798 6.73537C2.17065 6.37737 2.18132 6.11537 2.22798 5.88204C2.35017 5.26778 2.65177 4.70354 3.09463 4.26068C3.53749 3.81782 4.10172 3.51623 4.71598 3.39404C5.02265 3.33337 5.37865 3.33337 5.93732 3.33337ZM3.16865 6.73604C3.5523 6.84522 3.88989 7.0765 4.13026 7.39483C4.37063 7.71315 4.50066 8.10116 4.50065 8.50004V9.30004C4.50065 9.31871 4.51532 9.33337 4.53398 9.33337H11.4673C11.4762 9.33337 11.4846 9.32986 11.4909 9.32361C11.4971 9.31736 11.5007 9.30888 11.5007 9.30004V8.50004C11.5007 7.66137 12.064 6.95404 12.8327 6.73604C12.83 6.39604 12.8213 6.22271 12.7927 6.07737C12.7091 5.65698 12.5027 5.27081 12.1996 4.96773C11.8965 4.66465 11.5104 4.45827 11.09 4.37471C10.8927 4.33604 10.644 4.33337 10.0007 4.33337H6.00065C5.35732 4.33337 5.10865 4.33604 4.91132 4.37471C4.49092 4.45827 4.10476 4.66465 3.80168 4.96773C3.49859 5.27081 3.29222 5.65698 3.20865 6.07737C3.17998 6.22271 3.17132 6.39671 3.16865 6.73604ZM2.66732 7.66671C2.20732 7.66671 1.83398 8.04004 1.83398 8.50004V10.1294C1.83398 10.6255 2.03107 11.1013 2.38189 11.4521C2.73271 11.803 3.20852 12 3.70465 12H12.2967C12.7928 12 13.2686 11.803 13.6194 11.4521C13.9702 11.1013 14.1673 10.6255 14.1673 10.1294V8.50004C14.1673 8.27903 14.0795 8.06707 13.9232 7.91079C13.767 7.7545 13.555 7.66671 13.334 7.66671C13.113 7.66671 12.901 7.7545 12.7447 7.91079C12.5884 8.06707 12.5007 8.27903 12.5007 8.50004V9.30004C12.5007 9.5741 12.3918 9.83693 12.198 10.0307C12.0042 10.2245 11.7414 10.3334 11.4673 10.3334H4.53398C4.25993 10.3334 3.9971 10.2245 3.80331 10.0307C3.60952 9.83693 3.50065 9.5741 3.50065 9.30004V8.50004C3.50065 8.04004 3.12732 7.66671 2.66732 7.66671Z"
                fill="var(--c-secondary)"
              />
            </svg>
            <span v-else-if="isLetterPropertyCriteria">RE</span>
          </span>
          <p :class="isLetterPropertyCriteria ? 'tw-order-1' : 'tw-order-2'">
            {{ property.reception }}
          </p>
        </div>
      </div>
      <p class="tw-mt-6 tw-flex tw-items-center tw-gap-3 tw-text-start">
        <span
          ><svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M8 9.16602C7.50555 9.16602 7.0222 9.01939 6.61108 8.74469C6.19995 8.46999 5.87952 8.07954 5.6903 7.62273C5.50108 7.16591 5.45157 6.66324 5.54804 6.17829C5.6445 5.69334 5.8826 5.24788 6.23223 4.89825C6.58187 4.54862 7.02732 4.31052 7.51228 4.21405C7.99723 4.11759 8.4999 4.1671 8.95671 4.35632C9.41353 4.54554 9.80397 4.86597 10.0787 5.27709C10.3534 5.68821 10.5 6.17156 10.5 6.66602C10.4992 7.32881 10.2356 7.96424 9.76689 8.43291C9.29822 8.90158 8.6628 9.16522 8 9.16602ZM8 5.16602C7.70333 5.16602 7.41332 5.25399 7.16665 5.41881C6.91997 5.58363 6.72771 5.8179 6.61418 6.09199C6.50065 6.36608 6.47095 6.66768 6.52882 6.95865C6.5867 7.24962 6.72956 7.5169 6.93934 7.72668C7.14912 7.93646 7.41639 8.07932 7.70737 8.1372C7.99834 8.19507 8.29994 8.16537 8.57403 8.05184C8.84812 7.93831 9.08238 7.74605 9.24721 7.49937C9.41203 7.2527 9.5 6.96269 9.5 6.66602C9.4996 6.26831 9.34144 5.88701 9.06022 5.6058C8.779 5.32458 8.3977 5.16641 8 5.16602Z"
              fill="#90C73D"
            />
            <path
              d="M8.00001 15.166L3.78201 10.1915C3.7234 10.1168 3.66539 10.0417 3.60801 9.96602C2.8875 9.01691 2.49826 7.85763 2.50001 6.66602C2.50001 5.20732 3.07947 3.80838 4.11092 2.77693C5.14237 1.74548 6.54132 1.16602 8.00001 1.16602C9.4587 1.16602 10.8576 1.74548 11.8891 2.77693C12.9205 3.80838 13.5 5.20732 13.5 6.66602C13.5018 7.85709 13.1127 9.01584 12.3925 9.96452L12.392 9.96602C12.392 9.96602 12.242 10.163 12.2195 10.1895L8.00001 15.166ZM4.40651 9.36352C4.40651 9.36352 4.52301 9.51752 4.54951 9.55052L8.00001 13.62L11.455 9.54502C11.477 9.51752 11.594 9.36252 11.5945 9.36202C12.1831 8.58657 12.5012 7.63953 12.5 6.66602C12.5 5.47254 12.0259 4.32795 11.182 3.48404C10.3381 2.64012 9.19348 2.16602 8.00001 2.16602C6.80653 2.16602 5.66194 2.64012 4.81803 3.48404C3.97411 4.32795 3.50001 5.47254 3.50001 6.66602C3.49896 7.64014 3.81739 8.58772 4.40651 9.36352Z"
              fill="#90C73D"
            />
          </svg> </span
        >{{ property.display_address }}
      </p>
    </template>
    <template v-else>
      <lazy-library-text
        :text="property.display_address"
        class="n-capitalized tw-mt-[44px] tw-min-h-[48px]"
      ></lazy-library-text>
      <p class="tw-my-1">
        This is a pre-market property. You need to create an account and register to our property alerts in order to
        view it.
      </p>
      <div class="tw-my-10 tw-flex tw-gap-x-2">
        <nuxt-link
          :to="routes.REGISTER"
          class="pxp-search-properties-btn tw-w-fit"
          style="background-color: var(--purple); color: var(--white)"
          :external="true"
          >Register</nuxt-link
        >
        <nuxt-link
          :to="`${routes.PROPERTY_DETAIL.replace(':propertyId', property.property_profile_id)}#login`"
          class="pxp-search-properties-btn tw-w-fit"
          style="background-color: var(--purple); color: var(--white)"
          :external="true"
          >Login</nuxt-link
        >
      </div>
    </template>
    <div class="tw-mt-6">
      <p class="tw-line-clamp-4 tw-h-[96px] tw-whitespace-normal tw-text-start">{{ property.summary }}</p>
    </div>
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import { mapState } from 'pinia';
import type { PropertyItemComponent } from '~/units/properties/types';
import NcTooltip from '~/components/common/NcTooltip.vue';
import { useWebsiteStore } from '~/units/website/store';
import { ROUTES } from '~/constants/ui.constants';
import { PropertyMixin } from '~/units/properties/mixins/property.mixin';

export default defineNuxtComponent({
  name: 'PropertyListItem',
  components: { NcTooltip },

  mixins: [PropertyMixin],

  props: {
    property: {
      required: true,
      type: Object as PropType<PropertyItemComponent>,
    },

    isMatchInformationHidden: {
      required: false,
      type: Boolean,
      default: false,
    },

    version: {
      required: false,
      type: String,
      default: 'v1',
    },

    isLetterPropertyCriteria: {
      required: false,
      type: Boolean,
      default: false,
    },

    isSimpleVersion: {
      required: false,
      type: Boolean,
      default: false,
    },

    preMarketBlurText: {
      required: false,
      type: String,
    },
  },

  computed: {
    ...mapState(useWebsiteStore, ['theme']),
    routes() {
      return ROUTES;
    },

    design() {
      if (this.theme === 'theme3') {
        return {
          matchTagBg: 'background-color: var(--camel)',
          matchTextColor: 'color: var(--white)',
          advertHeadingColor: 'color: var(--black)',
        };
      }
      return {};
    },
  },
});
</script>

<style scoped>
.property-image {
  position: relative;
}
</style>
